// @ts-nocheck
import {useEffect, useState} from 'react'
import { Flex, Container, Box, Heading, Card,Button, HStack , Image, Text, ChakraProvider } from '@chakra-ui/react';
import specialCandy from './images/special-candy.png';
import colorBombCandy from './images/color-bomb-Candy.png';
import blueCandy from './images/blue-candy.png'
import greenCandy from './images/green-candy.png'
import orangeCandy from './images/orange-candy.png'
import purpleCandy from './images/purple-candy.png'
import redCandy from './images/red-candy.png'
import yellowCandy from './images/yellow-candy.png'
import blank from './images/blank.png'
import ScoreSection from './components/ScoreSection'
import AudioPlayer from './components/AudioPlayer';
import SettingsMenu from './components/settingsMenu';
import LevelModal from './components/LevelModal';
import specialSound from './SoundFX/specialSound.wav';
import match3Sound from './SoundFX/Match3coins.wav';
import match4Sound from './SoundFX/Match4coins.wav';
import match5Sound from './SoundFX/Match5coins.wav';
import colorBombSound from './SoundFX/ColorBomb.wav';
import wrappedCandySound from './SoundFX/wrappedCandy.wav';
import swedishFishSound from './SoundFX/SwedishFish.wav';
import buttonClickSound from './SoundFX/ClickSound.wav';
import TotalScore from './components/totalScore';

const width = 8
const candyColors = [
    blueCandy,
    orangeCandy,
    purpleCandy,
    redCandy,
    yellowCandy,
    greenCandy
]

const SPECIALCANDY = 'SPECIALCANDY' // Define the constant for special candy
const COLORBOMBCANDY = 'COLORBOMBCANDY'

const specialCandyImage = specialCandy

const colorBombCandyImage = colorBombCandy

const playSound = (sound) => {
  const audio = new Audio(sound);
  audio.play();
};


const App = ({ onReset }) => {
    const [currentColorArrangement, setCurrentColorArrangement] = useState([])
    const [squareBeingDragged, setSquareBeingDragged] = useState(null)
    const [squareBeingReplaced, setSquareBeingReplaced] = useState(null)
    const [scoreDisplay, setScoreDisplay] = useState(0)
    const [level, setLevel] = useState(1);
    const [isLevelModalOpen, setIsLevelModalOpen] = useState(false);
    const [isManual, setIsManual] = useState(false);
    const [resetKey, setResetKey] = useState(0);
	const [totalScore, setTotalScore] = useState(0);



    const checkForColumnOfFive = () => {
      for (let i = 0; i <= 39; i++) {
          const columnOfFive = [i, i + width, i + width * 2, i + width * 3, i + width * 4]
          const decidedColor = currentColorArrangement[i]
          const isBlank = currentColorArrangement[i] === blank
  
          if (columnOfFive.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
              columnOfFive.forEach(square => currentColorArrangement[square] = specialCandy) // Replace with special candy
              setScoreDisplay((score) => score + 5) // Update the score
              playSound(match5Sound);
              return true
          }
      }
  }
  

    const checkForRowOfFive = () => {
      for (let i = 0; i < 64; i++) {
          const rowOfFive = [i, i + 1, i + 2, i + 3, i + 4]
          const decidedColor = currentColorArrangement[i]
          const notValid = [5, 6, 7, 13, 14, 15, 21, 22, 23, 29, 30, 31, 37, 38, 39, 45, 46, 47, 53, 54, 55, 62, 63, 64]
          const isBlank = currentColorArrangement[i] === blank
  
          if (notValid.includes(i)) continue
  
          if (rowOfFive.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
              rowOfFive.forEach(square => currentColorArrangement[square] = specialCandy) // Replace with special candy
              setScoreDisplay((score) => score + 5) // Update the score
              playSound(match5Sound);
              return true
          }
      }
  }
  

    const checkForColumnOfFour = () => {
        for (let i = 0; i <= 39; i++) {
            const columnOfFour = [i, i + width, i + width * 2, i + width * 3]
            const decidedColor = currentColorArrangement[i]
            const isBlank = currentColorArrangement[i] === blank

            if (columnOfFour.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                setScoreDisplay((score) => score + 4)
                columnOfFour.forEach(square => currentColorArrangement[square] = colorBombCandy)
                playSound(match4Sound);
                return true
            }
        }
    }

    const checkForRowOfFour = () => {
        for (let i = 0; i < 64; i++) {
            const rowOfFour = [i, i + 1, i + 2, i + 3]
            const decidedColor = currentColorArrangement[i]
            const notValid = [5, 6, 7, 13, 14, 15, 21, 22, 23, 29, 30, 31, 37, 38, 39, 45, 46, 47, 53, 54, 55, 62, 63, 64]
            const isBlank = currentColorArrangement[i] === blank

            if (notValid.includes(i)) continue

            if (rowOfFour.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                setScoreDisplay((score) => score + 4)
                rowOfFour.forEach(square => currentColorArrangement[square] = colorBombCandy)
                playSound(match4Sound);
                return true
            }
        }
    }

    const checkForColumnOfThree = () => {
        for (let i = 0; i <= 47; i++) {
            const columnOfThree = [i, i + width, i + width * 2]
            const decidedColor = currentColorArrangement[i]
            const isBlank = currentColorArrangement[i] === blank

            if (columnOfThree.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                setScoreDisplay((score) => score + 3)
                columnOfThree.forEach(square => currentColorArrangement[square] = blank)
                playSound(match3Sound);
                return true
            }
        }
    }

    const checkForRowOfThree = () => {
        for (let i = 0; i < 64; i++) {
            const rowOfThree = [i, i + 1, i + 2]
            const decidedColor = currentColorArrangement[i]
            const notValid = [6, 7, 14, 15, 22, 23, 30, 31, 38, 39, 46, 47, 54, 55, 63, 64]
            const isBlank = currentColorArrangement[i] === blank

            if (notValid.includes(i)) continue

            if (rowOfThree.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                setScoreDisplay((score) => score + 3)
                rowOfThree.forEach(square => currentColorArrangement[square] = blank)
                playSound(match3Sound);
                return true
            }
        }
    }

    const checkForSpecialCandyCreation = () => {
      for (let i = 0; i < 60; i++) {
          const rowOfFive = [i, i + 1, i + 2, i + 3, i + 4];
          const decidedColor = currentColorArrangement[i];
          const isBlank = currentColorArrangement[i] === blank;
  
          if (rowOfFive.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
              rowOfFive.forEach(square => currentColorArrangement[square] = blank);
              currentColorArrangement[i] = specialCandy; // Create special candy at the start of the row
              setCurrentColorArrangement([...currentColorArrangement]);
              return true;
          }
      }
  
      for (let i = 0; i < 40; i++) {
          const columnOfFive = [i, i + width, i + width * 2, i + width * 3, i + width * 4];
          const decidedColor = currentColorArrangement[i];
          const isBlank = currentColorArrangement[i] === blank;
  
          if (columnOfFive.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
              columnOfFive.forEach(square => currentColorArrangement[square] = blank);
              currentColorArrangement[i] = specialCandy; // Create special candy at the start of the column
              setCurrentColorArrangement([...currentColorArrangement]);
              return true;
          }
      }
  
      return false;
  };
  

    
    const activateSpecialCandy = () => {
      let newColorArrangement = [...currentColorArrangement];
      let specialCandyCleared = false;
  
      for (let i = 0; i < 64; i++) {
          if (currentColorArrangement[i] === specialCandy) {
              specialCandyCleared = true;
              const row = Math.floor(i / width) * width;
              const column = i % width;
  
              // Clear the row where the special candy is located
              for (let j = row; j < row + width; j++) {
                  newColorArrangement[j] = blank;
              }
  
              // Clear the column where the special candy is located
              for (let j = column; j < 64; j += width) {
                  newColorArrangement[j] = blank;
              }
  
              // Remove the special candy itself
              newColorArrangement[i] = blank;
  
              setScoreDisplay((score) => score + 20); // Update the score
  
              playSound(specialSound); // Play sound effect
  
              break; // Exit the loop after handling the special candy
          }
      }
  
      if (specialCandyCleared) {
          setCurrentColorArrangement(newColorArrangement); // Update the state with new arrangement
      }
  };
  
  const checkForColorBombCandyCreation = () => {
    for (let i = 0; i < 60; i++) {
        // Check rows of 4
        if (i % width <= width - 4) { // Ensure we're within bounds for a row of 4
            const rowOfFour = [i, i + 1, i + 2, i + 3];
            const decidedColor = currentColorArrangement[i];
            const isBlank = currentColorArrangement[i] === blank;

            if (rowOfFour.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                rowOfFour.forEach(square => currentColorArrangement[square] = blank);
                currentColorArrangement[i] = colorBombCandy; // Create color bomb candy at the start of the row
                setCurrentColorArrangement([...currentColorArrangement]);
                return true;
            }
        }
    }

    for (let i = 0; i < 40; i++) {
        // Check columns of 4
        if (i + 3 * width < 64) { // Ensure we're within bounds for a column of 4
            const columnOfFour = [i, i + width, i + width * 2, i + width * 3];
            const decidedColor = currentColorArrangement[i];
            const isBlank = currentColorArrangement[i] === blank;

            if (columnOfFour.every(square => currentColorArrangement[square] === decidedColor && !isBlank)) {
                columnOfFour.forEach(square => currentColorArrangement[square] = blank);
                currentColorArrangement[i] = colorBombCandy; // Create color bomb candy at the start of the column
                setCurrentColorArrangement([...currentColorArrangement]);
                return true;
            }
        }
    }

    return false;
};

const activateColorBombCandy = () => {
    let newColorArrangement = [...currentColorArrangement];
    let colorBombCandyCleared = false;

    for (let i = 0; i < 64; i++) {
        if (currentColorArrangement[i] === colorBombCandy) {
            colorBombCandyCleared = true;
            const row = Math.floor(i / width); // Row index
            const column = i % width; // Column index

            // Clear the X diagonals crossing through the color bomb candy
            // Clear diagonal from top-left to bottom-right
            for (let j = -Math.min(row, column); j < Math.min(width - row, width - column); j++) {
                const index = i + j * (width + 1);
                if (index >= 0 && index < 64) {
                    newColorArrangement[index] = blank;
                }
            }

            // Clear diagonal from top-right to bottom-left
            for (let j = -Math.min(row, width - column - 1); j < Math.min(width - row, column + 1); j++) {
                const index = i + j * (width - 1);
                if (index >= 0 && index < 64) {
                    newColorArrangement[index] = blank;
                }
            }

            // Remove the color bomb candy itself
            newColorArrangement[i] = blank;

            setScoreDisplay((score) => score + 20); // Update the score

            playSound(colorBombSound); // Play sound effect

            break; // Exit the loop after handling the color bomb candy
        }
    }

    if (colorBombCandyCleared) {
        setCurrentColorArrangement(newColorArrangement); // Update the state with new arrangement
    }
};


  

    const moveIntoSquareBelow = () => {
        for (let i = 0; i <= 55; i++) {
            const firstRow = [0, 1, 2, 3, 4, 5, 6, 7]
            const isFirstRow = firstRow.includes(i)

            if (isFirstRow && currentColorArrangement[i] === blank) {
                let randomNumber = Math.floor(Math.random() * candyColors.length)
                currentColorArrangement[i] = candyColors[randomNumber]
            }

            if ((currentColorArrangement[i + width]) === blank) {
                currentColorArrangement[i + width] = currentColorArrangement[i]
                currentColorArrangement[i] = blank
            }
        }
    }

    const dragStart = (e) => {
        setSquareBeingDragged(e.target)
    }
    const dragDrop = (e) => {
        setSquareBeingReplaced(e.target)
    }
    const dragEnd = () => {
      const squareBeingDraggedId = parseInt(squareBeingDragged.getAttribute('data-id'))
      const squareBeingReplacedId = parseInt(squareBeingReplaced.getAttribute('data-id'))
  
      currentColorArrangement[squareBeingReplacedId] = squareBeingDragged.getAttribute('src')
      currentColorArrangement[squareBeingDraggedId] = squareBeingReplaced.getAttribute('src')
  
      const validMoves = [
          squareBeingDraggedId - 1,
          squareBeingDraggedId - width,
          squareBeingDraggedId + 1,
          squareBeingDraggedId + width
      ]
  
      const validMove = validMoves.includes(squareBeingReplacedId)
  
      const isAColumnOfFive = checkForColumnOfFive()
      const isARowOfFive = checkForRowOfFive()
      const isAColumnOfFour = checkForColumnOfFour()
      const isARowOfFour = checkForRowOfFour()
      const isAColumnOfThree = checkForColumnOfThree()
      const isARowOfThree = checkForRowOfThree()
      const isSpecialCandyActivated = activateSpecialCandy()
      const isColorBombCandyActivated = activateColorBombCandy()
  
      if (squareBeingReplacedId &&
          validMove &&
          (isARowOfFive || isAColumnOfFive || isARowOfThree || isARowOfFour || isAColumnOfFour || isAColumnOfThree || isSpecialCandyActivated || isColorBombCandyActivated )) {
          setSquareBeingDragged(null)
          setSquareBeingReplaced(null)
      } else {
          currentColorArrangement[squareBeingReplacedId] = squareBeingReplaced.getAttribute('src')
          currentColorArrangement[squareBeingDraggedId] = squareBeingDragged.getAttribute('src')
          setCurrentColorArrangement([...currentColorArrangement])
      }
  }
  
  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    const target = document.elementFromPoint(touch.clientX, touch.clientY);
    if (target) {
        setSquareBeingDragged(target);
    }
};

const handleTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    const target = document.elementFromPoint(touch.clientX, touch.clientY);
    if (target) {
        setSquareBeingReplaced(target);
    }
};

const handleTouchEnd = (e) => {
    e.preventDefault();
    if (squareBeingDragged && squareBeingReplaced) {
        const squareBeingDraggedId = parseInt(squareBeingDragged.getAttribute('data-id'));
        const squareBeingReplacedId = parseInt(squareBeingReplaced.getAttribute('data-id'));

        currentColorArrangement[squareBeingReplacedId] = squareBeingDragged.getAttribute('src');
        currentColorArrangement[squareBeingDraggedId] = squareBeingReplaced.getAttribute('src');

        const validMoves = [
            squareBeingDraggedId - 1,
            squareBeingDraggedId - width,
            squareBeingDraggedId + 1,
            squareBeingDraggedId + width
        ];

        const validMove = validMoves.includes(squareBeingReplacedId);

        const isAColumnOfFive = checkForColumnOfFive();
        const isARowOfFive = checkForRowOfFive();
        const isAColumnOfFour = checkForColumnOfFour();
        const isARowOfFour = checkForRowOfFour();
        const isAColumnOfThree = checkForColumnOfThree();
        const isARowOfThree = checkForRowOfThree();
        const isSpecialCandyActivated = activateSpecialCandy();
        const isColorBombCandyActivated = activateColorBombCandy();

        if (squareBeingReplacedId &&
            validMove &&
            (isARowOfFive || isAColumnOfFive || isARowOfThree || isARowOfFour || isAColumnOfFour || isAColumnOfThree || isSpecialCandyActivated || isColorBombCandyActivated )) {
            setSquareBeingDragged(null);
            setSquareBeingReplaced(null);
        } else {
            currentColorArrangement[squareBeingReplacedId] = squareBeingReplaced.getAttribute('src');
            currentColorArrangement[squareBeingDraggedId] = squareBeingDragged.getAttribute('src');
            setCurrentColorArrangement([...currentColorArrangement]);
        }
    }
}

const handlePointerDown = (e) => {
    // Handle pointer down logic
    e.preventDefault();
    setSquareBeingDragged(e.target);
  };

  const handlePointerMove = (e) => {
    // Handle pointer move logic
    e.preventDefault();
    if (squareBeingDragged) {
      setSquareBeingReplaced(e.target);
    }
  };

  const handlePointerUp = (e) => {
    // Handle pointer up logic
    e.preventDefault();
    if (squareBeingDragged && squareBeingReplaced) {
      const squareBeingDraggedId = parseInt(squareBeingDragged.getAttribute('data-id'));
      const squareBeingReplacedId = parseInt(squareBeingReplaced.getAttribute('data-id'));

      currentColorArrangement[squareBeingReplacedId] = squareBeingDragged.getAttribute('src');
      currentColorArrangement[squareBeingDraggedId] = squareBeingReplaced.getAttribute('src');

      const validMoves = [
        squareBeingDraggedId - 1,
        squareBeingDraggedId - width,
        squareBeingDraggedId + 1,
        squareBeingDraggedId + width
      ];

      const validMove = validMoves.includes(squareBeingReplacedId);

      const isAColumnOfFive = checkForColumnOfFive();
      const isARowOfFive = checkForRowOfFive();
      const isAColumnOfFour = checkForColumnOfFour();
      const isARowOfFour = checkForRowOfFour();
      const isAColumnOfThree = checkForColumnOfThree();
      const isARowOfThree = checkForRowOfThree();
      const isSpecialCandyActivated = activateSpecialCandy();
      const isColorBombCandyActivated = activateColorBombCandy();

      if (squareBeingReplacedId &&
        validMove &&
        (isARowOfFive || isAColumnOfFive || isARowOfThree || isARowOfFour || isAColumnOfFour || isAColumnOfThree || isSpecialCandyActivated || isColorBombCandyActivated )) {
        setSquareBeingDragged(null);
        setSquareBeingReplaced(null);
      } else {
        currentColorArrangement[squareBeingReplacedId] = squareBeingReplaced.getAttribute('src');
        currentColorArrangement[squareBeingDraggedId] = squareBeingDragged.getAttribute('src');
        setCurrentColorArrangement([...currentColorArrangement]);
      }
    }
  }

    const createBoard = () => {
        const randomColorArrangement = []
        for (let i = 0; i < width * width; i++) {
            const randomColor = candyColors[Math.floor(Math.random() * candyColors.length)]
            randomColorArrangement.push(randomColor)
        }
        setCurrentColorArrangement(randomColorArrangement)
    }

    useEffect(() => {
        createBoard()
    }, [])

    useEffect(() => {
        const timer = setInterval(() => {
          checkForColumnOfFive()
          checkForRowOfFive()
            checkForColumnOfFour()
            checkForRowOfFour()
            checkForColumnOfThree()
            checkForRowOfThree()
            moveIntoSquareBelow()
            setCurrentColorArrangement([...currentColorArrangement])
        }, 100)
        return () => clearInterval(timer)
    }, [checkForColumnOfFive, checkForRowOfFive, checkForColumnOfFour, checkForRowOfFour, checkForColumnOfThree, checkForRowOfThree, moveIntoSquareBelow, currentColorArrangement])

    useEffect(() => {
        if (scoreDisplay >= 1000000000) {
          setIsManual(false);
          setIsLevelModalOpen(true);
        }
      }, [scoreDisplay]);
    
      const handleNextLevel = () => {
        setLevel((prevLevel) => prevLevel + 1);
        setScoreDisplay(0);
        setIsLevelModalOpen(false);
        createBoard();
      };
    
      const handleReplay = () => {
        setScoreDisplay(0);
        setIsLevelModalOpen(false);
        createBoard();
      };

	  const handleReset = () => {
	      setTotalScore(0);
	      localStorage.setItem('totalScore', '0');
	      if (onReset) onReset();
	    };
      

    return (
        <Box w="100%" h="100%"   overflow="hidden">
            
 <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      
       
        
      <div className="app">
      <Card 
          bgColor="white" 
          borderColor="white" 
          borderStyle="solid" 
          width="100%" 
          height="40px" 
          border="2px solid white" 
          borderRadius={50} 
          display="flex" 
          alignItems="center" 
          justifyContent="center" 
          textAlign="center"
          p={2}
          m={2}
          className='card'
          
        >
          <Text color='white'><h1 >#MO&apos;s Crypto Crush</h1>
          </Text>
        </Card>
          <div className="game">
          
       
      
          {currentColorArrangement.map((candyColor, index) => (
    <img
        key={index}
        src={candyColor}
        alt={candyColor}
        data-id={index}
        draggable={true}
        onDragStart={dragStart}
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={(e) => e.preventDefault()}
        onDragLeave={(e) => e.preventDefault()}
        onDrop={dragDrop}
        onDragEnd={dragEnd}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        
    />
))}

          

      
          </div>
          <Card className='card'  size={"xs"} borderColor="5px solid white"  mt={1} border={"5px"} height={"80px"} 
          width={"96%"} display="flex" borderRadius={10}
          alignItems="center" justifyContent="space-between">

            <Card bgColor={"white"}   width={"100%"}
            height={"40px"} borderColor="5px solid red" borderRadius={50} display="flex"
             alignItems="center" justifyContent="center" textAlign={"center"} opacity={0.8}  style={{ marginBottom: '5px' }} >

          <ScoreSection scoreDisplay={scoreDisplay}/>

          </Card>
          

              
<div style={{ 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '20px', // Adjust the gap between cards as needed
  marginTop: '0px'
}}>
  {/* Card on the left */}
  <div style={{ flex: '1', display: 'flex', justifyContent: 'center' }}>
    <Card 
      bgColor="white" 
      borderColor="white" 
      borderStyle="solid" 
      width="120px" 
      height="35px" 
      border="1px solid red" 
      borderRadius={50} 
      display="flex" 
      alignItems="center" 
      justifyContent="center" 
      textAlign="center"
    >
      <h3 color='white'>Level: {level}</h3>
    </Card>
  </div>



  {/* Card on the right */}
  <div style={{ flex: '1' }}>
    <Card 
      bgColor="white" 
      borderColor="white" 
      borderStyle="solid" 
      width="120px" 
      height="35px" 
      border="1px solid red" 
      borderRadius={50} 
      display="flex" 
      alignItems="center" 
      justifyContent="center" 
      textAlign="center"
    >
      <SettingsMenu 
        onOpenLevelModal={() => { setIsManual(true); setIsLevelModalOpen(true); }} 
        onReset={handleReset} 
      />
    </Card>
  </div>
</div>

          </Card>

      </div>

    

      </div>

      <LevelModal
        isOpen={isLevelModalOpen}
        onClose={() => setIsLevelModalOpen(false)}
        onNextLevel={handleNextLevel}
        onReplay={handleReplay}
        isManual={isManual}
      />
    </Box>
  )
  
}

export default App

